import { Laboratory } from '@medprev-web-app/api-graphql-client';

import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

export const resolveLaboratoryName = (laboratory: Laboratory): string => {
  if (!laboratory?.main) {
    return '';
  }

  const { name } = laboratory;
  const { socialName, legalName } = laboratory.main || {} as Laboratory;

  if (socialName) {
    return [formatToTitleCase(socialName), formatToTitleCase(name as string)].join(' - ');
  }

  return [formatToTitleCase(legalName as string), formatToTitleCase(name as string)].join(' - ');
};
